<template>
  <b-navbar toggleable="lg" type="dark" variant="primary">
    <b-navbar-brand href="/">Meu Ateliê</b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item href="/products">Produtos</b-nav-item>
        <b-nav-item href="/configs">Opções</b-nav-item>                
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <!-- <b-nav-form>
          <b-form-input size="sm" class="mr-sm-2" placeholder="Search"></b-form-input>
          <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
        </b-nav-form> -->
       <template v-if="isAuth">
        <b-nav-item-dropdown right class="text-white">
          <!-- Using 'button-content' slot -->
          <template #button-content>
            <span class="text-bg-primary fs-2"><em>Olá, {{user.firstname}}</em></span>
          </template>
          <b-dropdown-item href="profile">Perfil</b-dropdown-item>
          <b-dropdown-item href="/contatos">Fale Conosco</b-dropdown-item>
          <b-dropdown-item @click="logout">Sair</b-dropdown-item>
        </b-nav-item-dropdown>
       </template> 
       <template v-else>
          <b-nav-item href="login">Login</b-nav-item>
       </template>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import store from "@/store"
import { defineComponent } from "vue"

export default defineComponent({
  name: 'NavMenu',
  props: {
    msg: String,
  },
  data(){
    return {
        auth: false,
        user:{}
    }
  },
  computed:{
    isAuth(){
      if (this.auth){
        return this.auth
      }
      return localStorage.getItem('isAuth').toLowerCase()===JSON.stringify(true)
    },
  },
  methods:{
    logout(){
      store.commit("setAuth",false)
      localStorage.setItem("isAuth", false)
      localStorage.setItem("user", null)
      localStorage.setItem("token", null)
      this.$router.push("login")
    }
  },
  created(){
    if (store.getters.isAuth) {
      this.auth = store.getters.isAuth
    }
    this.user = JSON.parse(localStorage.getItem("user") || "{}")
  }
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
